import { render, staticRenderFns } from "./regionalManagement.vue?vue&type=template&id=20600a12&scoped=true&"
import script from "./regionalManagement.vue?vue&type=script&lang=js&"
export * from "./regionalManagement.vue?vue&type=script&lang=js&"
import style0 from "./regionalManagement.vue?vue&type=style&index=0&id=20600a12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20600a12",
  null
  
)

export default component.exports